import { useViewPort } from "@website/hooks/viewport";
import { CtaPropertiesType } from "@website/ui/datepicker/components/cta/cta.types";

export const useCta = (properties: CtaPropertiesType) => {
  const { accept, acceptEmpty = false, reject, value, mode, view } = properties;
  const { isMobile } = useViewPort();

  const disabled =
    (mode === "single" && value.length === 0) ||
    (mode !== "single" && Boolean(acceptEmpty) !== true && value.length <= 1);

  return {
    acceptButtonProperties: {
      onClick: accept,
      color: "secondary" as const,
      size: "large" as const,
      variant: "contained" as const,
      fullWidth: isMobile || view === "mobile",
      disabled
    },
    rejectButtonProperties: {
      onClick: reject,
      color: "secondary" as const,
      size: "large" as const,
      variant: "text" as const,
      fullWidth: isMobile || view === "mobile",
      disabled
    }
  };
};
